import type { TaskStatus } from "@shared/types";

/**
 * Canonical display labels for the four task statuses. Mirrors
 * `projectStatus.ts`. Use this everywhere a task status is rendered to
 * keep casing consistent ("To Do" vs "Todo", "Doing" vs "In progress").
 */
export const TASK_STATUS_LABEL: Record<TaskStatus, string> = {
  backlog: "Backlog",
  todo: "To Do",
  doing: "Doing",
  done: "Done",
};

/**
 * Canonical board ordering — left-to-right column order in the kanban,
 * top-to-bottom group order in the task list.
 */
export const taskStatusOrder: TaskStatus[] = [
  "backlog",
  "todo",
  "doing",
  "done",
];
